import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { AuthService } from "src/app/providers/auth.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { AddMemberComponent } from "src/app/shared/components/add-member/add-member.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { UpdateInterestStatusReplyComponent } from "../update-interest-status-reply/update-interest-status-reply.component";
import { DialogService } from "src/app/providers/dialog.service";

@Component({
  selector: "sm-joining-interest-details",
  templateUrl: "./joining-interest-details.component.html",
  styleUrls: ["./joining-interest-details.component.scss"],
})
export class JoiningInterestDetailsComponent implements OnInit, OnDestroy {
  apisub: Subscription;
  interestDetails: any = [];
  loader: boolean = false;
  constructor(
    private apiservice: ApiService,
    private ls: LoaderServiceService,
    private navservice: NavigationService,
    private route: ActivatedRoute,
    private authService: AuthService,
    private dialog: MatDialog,
    private dialogService: DialogService,
    private router: Router
  ) {
    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      this.navservice.hideSidebarAndNav = false;
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENROLL_INTEREST_DETAILS_BY_ID
      ) {
        this.interestDetails = [];
        if (resdata.result) {
          this.interestDetails = resdata.result;
          this.interestDetails[0].entityInfo =
            typeof this.interestDetails[0].entityInfo == "string"
              ? JSON.parse(this.interestDetails[0].entityInfo)
              : this.interestDetails[0].entityInfo;

          this.interestDetails[0].request_services =
            typeof this.interestDetails[0].request_services == "string"
              ? JSON.parse(this.interestDetails[0].request_services)
              : this.interestDetails[0].request_services;
          this.interestDetails[0].custom_items =
            typeof this.interestDetails[0].custom_items == "string"
              ? JSON.parse(this.interestDetails[0].custom_items)
              : this.interestDetails[0].custom_items;
          this.interestDetails[0].products =
            typeof this.interestDetails[0].products == "string"
              ? JSON.parse(this.interestDetails[0].products)
              : this.interestDetails[0].products;
          this.interestDetails[0].request_timings =
            typeof this.interestDetails[0].request_timings == "string"
              ? JSON.parse(this.interestDetails[0].request_timings)
              : this.interestDetails[0].request_timings;
          this.interestDetails[0].entityInfo =
            typeof this.interestDetails[0].entityInfo == "string"
              ? JSON.parse(this.interestDetails[0].entityInfo)
              : this.interestDetails[0].entityInfo;
          this.interestDetails[0].coupon_info =
            typeof this.interestDetails[0].coupon_info == "string"
              ? JSON.parse(this.interestDetails[0].coupon_info)
              : this.interestDetails[0].coupon_info;
          this.interestDetails[0].user_profile_data =
            typeof this.interestDetails[0].user_profile_data == "string"
              ? JSON.parse(this.interestDetails[0].user_profile_data)
              : this.interestDetails[0].user_profile_data;
          if(this.interestDetails[0].user_profile_data){
          this.interestDetails[0].user_profile_data.address_info =
            typeof this.interestDetails[0].user_profile_data.address_info == "string"
              ? JSON.parse(this.interestDetails[0].user_profile_data.address_info)
              : this.interestDetails[0].user_profile_data.address_info;
            
          }
          this.interestDetails[0].phone =
            this.interestDetails[0].customer_country_code +
            " " +
            this.interestDetails[0].customer_phone;

          this.interestDetails[0].opted_services = this.interestDetails[0]
            .request_services
            ? this.getServiceNames(this.interestDetails[0].request_services)
            : null;
          this.interestDetails[0].opted_products = this.interestDetails[0]
            .products
            ? this.getProductsNames(this.interestDetails[0].products)
            : null;
          this.interestDetails[0].opted_cis = this.interestDetails[0]
            .custom_items
            ? this.getCustomItemNames(this.interestDetails[0].custom_items)
            : null;
          this.interestDetails[0].opted_timings = this.interestDetails[0]
            .request_timings
            ? this.formatSchedule(this.interestDetails[0].request_timings)
            : null;

          if (this.interestDetails[0].enrollment_request_status == 1) {
            this.interestDetails[0].item_status = "New";
          } else if (this.interestDetails[0].enrollment_request_status == 2) {
            this.interestDetails[0].item_status = "In progress";
          } else if (this.interestDetails[0].enrollment_request_status == 3) {
            this.interestDetails[0].item_status = "Marked as enrolled";
          } else if (this.interestDetails[0].enrollment_request_status == 4) {
            this.interestDetails[0].item_status = "Cancelled";
          } else if (this.interestDetails[0].enrollment_request_status == 5) {
            this.interestDetails[0].item_status = "Enrolled";
          }

          if (this.interestDetails[0].interest_type == 0) {
            this.interestDetails[0].service_mode = "Home service";
          } else if (this.interestDetails[0].interest_type == 1) {
            this.interestDetails[0].service_mode = "In-premise service";
          } else if (this.interestDetails[0].interest_type == 2) {
            this.interestDetails[0].service_mode = "Virtual service";
          }
          console.log(this.interestDetails);
        }

        this.ls.showLoader = false;
        this.loader = false;
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_ENROLL_PROGRESS_STATUS
      ) {
        if (resdata.result) {
          if (this.currentStatusOfChange == 3) {
            this.ls.showLoader = false;
            const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
              width: "500px",
              data: {
                title: "Success !",
                message:
                  "The status changed to Enrolled is successfully done. Do you want to add this person as a member now?",
                cancelbtn: "I'll do later",
                okbtn: "Add as member",
                type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
              },
              disableClose: true,
            });
            dialogRef.afterClosed().subscribe((res) => {
              if (res) {
                let data1 = {
                  title: "Add member",
                  ref: this.dialog,
                  data: {
                    entityHash: this.entityHash,
                    memberData: this.currentMemberOfChange,
                    // serviceType: this.interestType,
                  },
                };
                let dialogref = this.dialogService.openFullScreenDialog(
                  AddMemberComponent,
                  data1
                );
                dialogref.afterClosed().subscribe((res) => {
                  if (res) {
                    if (res.errorcode == 1) {
                      this.ls.showLoader = false;
                      const dialogRef = this.dialog.open(
                        CustomConfirmDialogComponent,
                        {
                          width: "500px",
                          data: {
                            title: "Alert",
                            message:
                              "There's another member with the same name and phone number exists. If you really want to create one, change the name or phone number.",
                            okbtn: "Ok",
                            cancelbtn: "Cancel",
                            type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
                          },
                          disableClose: true,
                        }
                      );
                    } else if (res.errorcode == 2) {
                      this.ls.showLoader = false;
                      const dialogRef = this.dialog.open(
                        CustomConfirmDialogComponent,
                        {
                          width: "500px",
                          data: {
                            title: "Alert",
                            message:
                              "There's a person with the same name and phone number exists as your ex member. You can revive the membership again in 'Ex-members' section.",
                            okbtn: "Ok",
                            cancelbtn: "Cancel",
                            type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
                          },
                          disableClose: true,
                        }
                      );
                    } else {
                      // this.loader = true
                      this.ls.showLoader = true;
                      this.apiservice.getEnrollInterestDetailsById(
                        this.queryHash
                      );
                    }
                  } else {
                    this.ls.showLoader = true;
                    this.apiservice.getEnrollInterestDetailsById(
                      this.queryHash
                    );
                  }
                });
              } else {
                this.ls.showLoader = true;
                this.apiservice.getEnrollInterestDetailsById(this.queryHash);
              }
            });
          } else {
            this.apiservice.getEnrollInterestDetailsById(this.queryHash);
          }
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_ENTITY_REQUEST_DATA
      ) {
        if (resdata.result) {
          this.router.navigate(["../"], {
            relativeTo: this.route,
            queryParamsHandling: "preserve",
          });
        }
      }
    });
  }
  queryHash: any;
  entityHash: any;
  isOwner: boolean = false;
  ngOnInit(): void {
    this.isOwner = this.authService.isOwner();
    // console.log(this.parentData);
    this.route.queryParams.subscribe((data) => {
      if (data.queryHash) {
        this.queryHash = data.queryHash;
        this.entityHash = data.entityHash;
        this.loader = true;
        this.ls.showLoader = true;
        this.apiservice.getEnrollInterestDetailsById(this.queryHash);
      }
    });
  }

  getServiceNames(services: any) {
    console.log(services);

    return services.map((service: any) => service.service_name).join(", ");
  }

  getProductsNames(products: any) {
    console.log(products);

    return products.map((product: any) => product.product_name).join(", ");
  }

  getCustomItemNames(cis: any) {
    console.log(cis);

    return cis.map((ci: any) => ci.item_name).join(", ");
  }

  formatSchedule(schedule: any[]) {
    return schedule.map((item) => {
      const weekday = this.getWeekdayString(item.weekday);
      const startTime = this.formatTime(item.start_time);
      const endTime = this.formatTime(item.end_time);
      return `${weekday}: ${startTime} - ${endTime}`;
    });
  }

  formatTime(time: string): string {
    const [hour, minute] = time.split(":").map(Number);
    const period = hour >= 12 ? "PM" : "AM";
    const adjustedHour = hour % 12 || 12; // Convert 0 or 12 to 12 for AM/PM time
    return `${adjustedHour}:${minute.toString().padStart(2, "0")} ${period}`;
  }

  getWeekdayString(weekday: number): string {
    const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return weekdays[weekday - 1]; // Adjusting because weekday starts from 1
  }

  addReply(rowvalue: any) {
    let dialogRef = this.dialog.open(UpdateInterestStatusReplyComponent, {
      width: "500px",
      data: {
        data: rowvalue,
        entityHash: this.entityHash,
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.apiservice.getEnrollInterestDetailsById(this.queryHash);
      }
    });
  }

  currentStatusOfChange: any;
  currentMemberOfChange: any;
  changeRequestStatus(item: any, status: any) {
    let statusMessage = "";
    if (status == 1) {
      statusMessage = "Are you sure want to mark the query as new?";
    } else if (status == 2) {
      statusMessage = "Are you sure want to mark the query as in-progress?";
    } else if (status == 3) {
      statusMessage = "Are you sure want to mark the person as enrolled?";
    } else if (status == 4) {
      statusMessage = "Are you sure want to mark the query as cancelled?";
    }

    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      width: "500px",
      data: {
        title: "Alert",
        message: statusMessage,
        cancelbtn: "Cancel",
        okbtn: "Confirm",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.currentStatusOfChange = status;
        this.currentMemberOfChange = item;
        let obj = {
          hash_id: item.hash_id,
          entity_hash: this.entityHash,
          status: status,
        };

        this.ls.showLoader = true;
        this.apiservice.updateEnrollInterestProgressStatus(obj);
      }
    });
  }

  addAsMember(item: any) {
    let data = {
      title: "Add member",
      ref: this.dialog,
      data: {
        entityHash: this.entityHash,
        memberData: item,
        // serviceType: this.interestType,
      },
    };

    let dialogref = this.dialogService.openFullScreenDialog(
      AddMemberComponent,
      data
    );
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        if (res.errorcode == 1) {
          this.ls.showLoader = false;
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
            width: "500px",
            data: {
              title: "Alert",
              message:
                "There's another member with the same name and phone number exists. If you really want to create one, change the name or phone number.",
              okbtn: "Ok",
              cancelbtn: "Cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
            },
            disableClose: true,
          });
        } else if (res.errorcode == 2) {
          this.ls.showLoader = false;
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
            width: "500px",
            data: {
              title: "Alert",
              message:
                "There's a person with the same name and phone number exists as your ex member. You can revive the membership again in 'Ex-members' section.",
              okbtn: "Ok",
              cancelbtn: "Cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
            },
            disableClose: true,
          });
        } else if (res.errorcode == 0) {
          if (res.whatsapp_share == 0 && res.email_share == 1) {
            const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
              width: "500px",
              data: {
                title: "Pack expired!",
                message:
                  "Enrolment successfully done for the new member. But unable to send the confirmation via WhatsApp as Premium pack expired for this business. ",
                okbtn: "Buy pack",
                cancelbtn: "Cancel",
                type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
              },
              disableClose: true,
            });
            dialogRef.afterClosed().subscribe((result) => {
              console.log(result);
              if (result) {
                this.router.navigate(
                  ["/businesses", "details", "plan-and-renew"],
                  {
                    queryParams: { entityHash: this.entityHash },
                  }
                );
              }
            });
          } else if (res.whatsapp_share == 1 && res.email_share == 0) {
            const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
              width: "500px",
              data: {
                title: "Pack expired!",
                message:
                  "Enrolment successfully done for the new member. But unable to send the confirmation Email as Premium pack expired for this business. ",
                okbtn: "Buy pack",
                cancelbtn: "Cancel",
                type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
              },
              disableClose: true,
            });
            dialogRef.afterClosed().subscribe((result) => {
              console.log(result);
              if (result) {
                this.router.navigate(
                  ["/businesses", "details", "plan-and-renew"],
                  {
                    queryParams: { entityHash: this.entityHash },
                  }
                );
              }
            });
          } else if (res.whatsapp_share == 0 && res.email_share == 0) {
            const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
              width: "500px",
              data: {
                title: "Pack expired!",
                message:
                  "Enrolment successfully done for the new member. But unable to send the confirmation via Email and WhatsApp as Premium pack expired for this business. ",
                okbtn: "Buy pack",
                cancelbtn: "Cancel",
                type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
              },
              disableClose: true,
            });
            dialogRef.afterClosed().subscribe((result) => {
              console.log(result);
              if (result) {
                this.router.navigate(
                  ["/businesses", "details", "plan-and-renew"],
                  {
                    queryParams: { entityHash: this.entityHash },
                  }
                );
              }
            });
          }
          this.ls.showLoader = true;
          this.apiservice.getEnrollInterestDetailsById(this.queryHash);
        }
      }
    });
  }

  formatDate1(dateStr: Date) {
    let curdate = new Date(dateStr)
      .toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .slice(0, 10);

    return curdate;
  }

  deleteQuery(item: any) {
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this query?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          customerHash: item.hash_id,
          entityHash: this.entityHash,
        };

        this.ls.showLoader = true;
        this.apiservice.deleteEntityRequestData(obj);
      }
    });
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }
}
